import { useState } from 'react';
import { useAuth } from '../lib/auth.js';
import { ChangePasswordDialog } from './ChangePasswordDialog.js';
import s from './TopBar.module.scss';

export function TopBar() {
  const { admin, logout } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);
  const [pwOpen, setPwOpen] = useState(false);

  if (!admin) return null;

  const handleLogout = async (): Promise<void> => {
    setLoggingOut(true);
    try {
      await logout();
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <header className={s.topbar}>
      <span className={s.email}>{admin.email}</span>
      <button type="button" className={s.logout} onClick={() => setPwOpen(true)}>
        Change password
      </button>
      <button
        type="button"
        className={s.logout}
        onClick={() => {
          void handleLogout();
        }}
        disabled={loggingOut}
      >
        {loggingOut ? 'Signing out…' : 'Sign out'}
      </button>
      <ChangePasswordDialog open={pwOpen} onOpenChange={setPwOpen} />
    </header>
  );
}
